import { Divider, Typography } from '@material-ui/core'
import * as React from 'react'

import { textStyles } from '../../styles/TextStyles'

interface Props {
    text: string
}

export const SectionTitle : React.FC<Props> = ({ text }) => {
    const classes = textStyles()

    return (
        <div>
            <Typography
                className={classes.title}>
                {text}
            </Typography>
            <Divider className={classes.divider}/>
        </div>
    )
}

export const SectionSubTitle : React.FC<Props> = ({ text }) => {
    const classes = textStyles()

    return (
        <div className={classes.container}>
            <Typography
                className={classes.subTitle}
                variant="h5">
                {text}
            </Typography>
        </div>
    )
}
